export enum DirectionEnum {
  Up = 'up',
  Down = 'down',
  First = 'first',
  Last = 'last',
}
